import React, { useRef } from 'react';
import { X, Printer, Eye } from 'lucide-react';
import { Button } from '../Button';
import { PreviewImpressao } from '../PreviewImpressao';
import { Ordem, PedidoDetalhe } from '../../types';
import './styles.css';

interface ModalImpressaoProps {
  ordem: Ordem;
  pedidos: PedidoDetalhe[];
  onClose: () => void;
}

export const ModalImpressao: React.FC<ModalImpressaoProps> = ({ ordem, pedidos, onClose }) => {
  const printContentRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => {
    if (!printContentRef.current) return;

    // Cria uma nova janela para impressão
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Por favor, permita pop-ups para esta funcionalidade funcionar.');
      return;
    }

    // Obtém o HTML do conteúdo de impressão
    const printContent = printContentRef.current.innerHTML;
    
    // Obtém os estilos CSS
    const styles = Array.from(document.styleSheets)
      .map(styleSheet => {
        try {
          return Array.from(styleSheet.cssRules)
            .map(rule => rule.cssText)
            .join('\n');
        } catch (e) {
          return '';
        }
      })
      .join('\n');

    // Cria o documento HTML completo para impressão
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Ordem de Serviço #${ordem.id}</title>
          <style>
            ${styles}
            @page {
              size: 80mm auto;
              margin: 0;
              padding: 5mm;
            }
            body {
              width: 80mm;
              margin: 0;
              padding: 0;
              font-family: 'Courier New', monospace;
              font-size: 9px;
              background: white;
            }
            .preview-impressao {
              width: 70mm;
              max-width: 70mm;
              margin: 0;
              padding: 5mm;
            }
            button, .no-print {
              display: none !important;
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

    printWindow.document.close();
    
    // Aguarda o carregamento e imprime
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
        // Fecha a janela após impressão (opcional)
        // printWindow.close();
      }, 250);
    };
  };

  return (
    <div className="modal-impressao-overlay" onClick={onClose}>
      <div className="modal-impressao-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-impressao-header">
          <h2 className="modal-impressao-title">
            <Printer className="icon-small" />
            Imprimir Ordem de Serviço #{ordem.id}
          </h2>
          <Button
            onClick={onClose}
            variant="ghost"
            size="icon"
            className="modal-impressao-close-button"
          >
            <X className="icon-close" />
          </Button>
        </div>

        <div className="modal-impressao-content">
          <div className="modal-impressao-preview-container">
            <div ref={printContentRef} className="modal-impressao-preview-wrapper">
              <PreviewImpressao ordem={ordem} pedidos={pedidos} />
            </div>
          </div>
        </div>

        <div className="modal-impressao-footer">
          <Button
            onClick={onClose}
            variant="outline"
            className="modal-impressao-button-cancel"
          >
            Cancelar
          </Button>
          <Button
            onClick={handlePrint}
            className="modal-impressao-button-print"
          >
            <Printer className="icon-small" />
            Imprimir
          </Button>
        </div>
      </div>
    </div>
  );
};

